<template>
  <page class="ab-screen">
    <unbounce-poster
      paragraph="Don't <span style='font-weight: bold; font-style: italic'>give</span> your data to Big Tech firms, <span style='font-weight: bold; font-style: italic'>rent</span> it out to advertisers and make them pay you for it."
    >
      <div class="column">
        <sign-up-form />
      </div>
    </unbounce-poster>
    <unbounce-rewards-rows />
    <page-info-footer-row class="footer" :enabled="true" />
    <page-poster
      :headline="$t('rewards.poster.headline', { class: 'blue' })"
      :paragraphs="[$t('rewards.poster.paragraph')]"
    />
    <rewards-group
      :headline="group1.headline"
      :iconSrc="group1.src"
      :iconAlt="group1.alt"
      :items="group1.items"
    />
    <rewards-group
      :headline="group2.headline"
      :iconSrc="group2.src"
      :iconAlt="group2.alt"
      :items="group2.items"
    />
    <page-info-footer-row class="footer" :enabled="true" />
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import UnbouncePoster from '@/components/unbounce/UnbouncePoster.vue';
import SignUpForm from '@/views/ab/SignUpForm.vue';
import PagePoster from '@/components/common/PagePoster.vue';
import UnbounceRewardsRows from '@/components/unbounce/UnbounceRewardsRows.vue';
import PageInfoFooterRow from '@/components/common/PageInfoFooterRow.vue';
import RewardsGroup from '@/components/rewards/RewardsGroup.vue';

export default {
  components: {
    Page,
    UnbouncePoster,
    SignUpForm,
    PagePoster,
    UnbounceRewardsRows,
    PageInfoFooterRow,
    RewardsGroup,
  },
  data() {
    return {
      group1: {
        headline: this.$t('rewards.group-1.headline'),
        src: '/img/icons/check.svg',
        alt: this.$t('rewards.group-1.iconAlt'),
        items: [
          [
            this.$t('rewards.group-1.item-1.paragraph-1'),
            this.$t('rewards.group-1.item-1.paragraph-2'),
          ],
          [
            this.$t('rewards.group-1.item-2.paragraph-1'),
            this.$t('rewards.group-1.item-2.paragraph-2'),
          ],
          [this.$t('rewards.group-1.item-3.paragraph')],
          [this.$t('rewards.group-1.item-4.paragraph')],
        ],
      },
      group2: {
        headline: this.$t('rewards.group-2.headline'),
        src: '/img/icons/notcheck.svg',
        alt: this.$t('rewards.group-2.iconAlt'),
        items: [
          [this.$t('rewards.group-2.item-1.paragraph')],
          [this.$t('rewards.group-2.item-2.paragraph')],
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 25px;
}
.poster {
  padding-top: 20px;
}
</style>
